"use strict";
var bicycling_layer_1 = require('./directives/bicycling-layer');
exports.BicyclingLayer = bicycling_layer_1.BicyclingLayer;
var navigator_geolocation_1 = require('./services/navigator-geolocation');
exports.NavigatorGeolocation = navigator_geolocation_1.NavigatorGeolocation;
var option_builder_1 = require('./services/option-builder');
exports.OptionBuilder = option_builder_1.OptionBuilder;
var config_1 = require('./services/config');
exports.NG_MAP_CONFIG_TOKEN = config_1.NG_MAP_CONFIG_TOKEN;
var ng2_map_component_1 = require('./components/ng2-map.component');
exports.Ng2MapComponent = ng2_map_component_1.Ng2MapComponent;
var info_window_1 = require('./components/info-window');
exports.InfoWindow = info_window_1.InfoWindow;
var custom_marker_1 = require('./components/custom-marker');
exports.CustomMarker = custom_marker_1.CustomMarker;
var circle_1 = require('./directives/circle');
exports.Circle = circle_1.Circle;
var data_layer_1 = require('./directives/data-layer');
exports.DataLayer = data_layer_1.DataLayer;
var directions_renderer_1 = require('./directives/directions-renderer');
exports.DirectionsRenderer = directions_renderer_1.DirectionsRenderer;
var drawing_manager_1 = require('./directives/drawing-manager');
exports.DrawingManager = drawing_manager_1.DrawingManager;
var geo_coder_1 = require('./services/geo-coder');
exports.GeoCoder = geo_coder_1.GeoCoder;
var ground_overlay_1 = require('./directives/ground-overlay');
exports.GroundOverlay = ground_overlay_1.GroundOverlay;
var heatmap_layer_1 = require('./directives/heatmap-layer');
exports.HeatmapLayer = heatmap_layer_1.HeatmapLayer;
var kml_layer_1 = require('./directives/kml-layer');
exports.KmlLayer = kml_layer_1.KmlLayer;
var marker_1 = require('./directives/marker');
exports.Marker = marker_1.Marker;
var ng2_map_1 = require('./services/ng2-map');
exports.Ng2Map = ng2_map_1.Ng2Map;
var places_auto_complete_1 = require('./directives/places-auto-complete');
exports.PlacesAutoComplete = places_auto_complete_1.PlacesAutoComplete;
var polygon_1 = require('./directives/polygon');
exports.Polygon = polygon_1.Polygon;
var polyline_1 = require('./directives/polyline');
exports.Polyline = polyline_1.Polyline;
var street_view_panorama_1 = require('./directives/street-view-panorama');
exports.StreetViewPanorama = street_view_panorama_1.StreetViewPanorama;
var traffic_layer_1 = require('./directives/traffic-layer');
exports.TrafficLayer = traffic_layer_1.TrafficLayer;
var transit_layer_1 = require('./directives/transit-layer');
exports.TransitLayer = transit_layer_1.TransitLayer;
var ng2_map_module_1 = require('./ng2-map.module');
exports.Ng2MapModule = ng2_map_module_1.Ng2MapModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-map/dist/index.js
// module id = 42
// module chunks = 0